import { createContext } from 'react';

import { ConvertibleUnit, FormatOptions, Unit } from '@dynatrace-sdk/units';

import { ChartUnit } from '../../core/types/chart-unit.js';
import { Formatter } from '../../core/types/formatter.js';

export type FormatterContextProps = {
  /**
   * Honeycomb's tile values formatter
   * @defaultValue the default formatter
   */
  formatter: Formatter | FormatOptions<Unit, ConvertibleUnit> | undefined;
  /**
   * Custom unit for honeycomb's tiles values.
   */
  unit?: ChartUnit;
};

export const HoneycombFormatterContext = createContext<FormatterContextProps>({
  formatter: undefined,
  unit: '',
});
